module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K26CGK1.4f8aac60.jpg";